module.exports = __webpack_public_path__ + "files/5af5fa927b5a0222b26fe7303b2581ec.png";